import React from 'react';
import { Route, BrowserRouter as Router, Switch } from 'react-router-dom';
import App from './App';
// import Login from './Login';
// import Stop from './Stop';

export default function Routes({ history }) {
  return (
    <React.Fragment>
      <App history={history} />
      {/* <Router>
        <Switch>
          <Route exact path="/" component={() => <App history={history} />} />
          <Route
            exact
            path="/run"
            component={() => <App history={history} />}
          />
          <Route
            exact
            path="/stop"
            component={() => <Stop history={history} />}
          />
        </Switch>
      </Router> */}
    </React.Fragment>
  );
}


{/* <Login history={history} /> */}